'use client'

import { useReduxSelector } from '@/store/hooks'

import { MenuCommonRoot } from '../MenuCommon/MenuCommonRoot/MenuCommonRoot'

import styles from './MenuNav.module.scss'
import { MenuNavMain } from './MenuNavMain/MenuNavMain'
import { MenuNavQuickLinks } from './MenuNavQuickLinks/MenuNavQuickLinks'

export const MenuNav = () => {
  const isNavOpen = useReduxSelector((s) => s.view.mobileStatus === 'nav')

  return (
    <MenuCommonRoot isOpen={isNavOpen} variant='nav'>
      {isNavOpen && (
        <div className={styles.container}>
          <MenuNavMain />
          <MenuNavQuickLinks />
        </div>
      )}
    </MenuCommonRoot>
  )
}
